import { Injectable } from '@angular/core';

import {  HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';

let RegpatHistoryOnOldSystemlUrl = CONFIG.baseUrls.regpatHistoryOnOldSystem;

export interface RegpatHistoryOnOldSystem  {
    serial: number;
    visitCode: number;
    patientCode: number;
    patientName: string;
    referralSource: number;
    phoneNumber: string;
    organizationName: string;
    serviceName: string;
    doctorName: string;
    visitDateTime:Date;
    branchName : string; 
    fullnameAr:string;
    fullnameEn:string;
}

@Injectable()
export class RegpatHistoryOnOldSystemService {

    constructor(private httpGeneralService: HttpGeneralService) { }


    getPatOldSystemHistoryDetail(serial: number) {
        return this.httpGeneralService.get(serial, RegpatHistoryOnOldSystemlUrl)
    }

    deletePatOldSystemHistory(serial:number){
        return this.httpGeneralService.delete(serial,RegpatHistoryOnOldSystemlUrl);
    }
    getPatOldImage(imageId: number) {
        return this.httpGeneralService.get(imageId, `${RegpatHistoryOnOldSystemlUrl}/getImagePreview`);
    }
}